(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('UserProfileController', UserProfileController);

    UserProfileController.$inject = ['PersonInfo', 'UserProfileQuery', 'LocationInfo', '$translate', '$scope', 'SelectorData', 'SelectorDataQuery', 'entity'];

    function UserProfileController(PersonInfo, UserProfileQuery, LocationInfo, $translate, $scope, SelectorData, SelectorDataQuery, entity) {
        var vm = this;
        vm.personInfo = entity;
        vm.accid = null;
        vm.error = null;
        vm.save = save;
        vm.settingsAccount = null;
        vm.success = null;
        vm.success = true;
        vm.selectordata = SelectorData.query();
        vm.blockEditPhoneNumber = true;

        function save() {
            //
            vm.isSaving = true;

            if (vm.personInfo.id !== null) {
                PersonInfo.update(vm.personInfo, onSaveSuccess, onSaveError);
            } else {
                // ServiceItem.save(vm.serviceItem, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:userProfileUpdate', result);
            vm.personInfo = result;
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }


    }
})();
